module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('no-record', {
    attrs: {
      "condition": _vm.voucherList,
      "tips": "请先添加就诊人"
    }
  }), _vm._v(" "), _vm._l((_vm.voucherList), function(voucher, index) {
    return _c('voucher-item', {
      key: index,
      staticClass: "voucher-list",
      class: (0 == index) ? 'selected' : '',
      attrs: {
        "id": 'profile-voucherItem-' + voucher.cardNo,
        "voucher": voucher,
        "edit": 0,
        "is-frequent": index === 0
      },
      on: {
        "selected": function($event) {
          return _vm.selectVoucher(voucher, index, $event)
        }
      }
    })
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7c4804","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/healthRecord/VoucherSelect.vue
// module id = 796
// module chunks = 0